<template>
    <div>
        <h5 id="internship-title" class="section">
            Internships
        </h5>
        <el-card :span="18" class="box-card" id="internship">
            <!-- <p class="research">
            Research Assistant | MadAbility Lab, University of Wisconsin-Madison
            </p>
            <p class="research-time">
            August 2023 -- present
            </p>
            <el-divider></el-divider> -->
            <p class="research">
            Research & Development Intern | Niantic Spatial, Inc.
            </p>
            <p class="research-time">
            Advised by Dr. Jessica Van Brummelen and Prof. Gabriel Brostow, May 2025 -- September 2025
            </p>
            <p class="research-content">
              Worked on designing AI agent-based AR phone applications for blind and low vision users. Co-first author paper to be appeared in CHI'26.
            </p>
        </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'InternshipSection',
    data() {
      return {
      };
    }
  };
  </script>
  
  <style>
  </style>